export default "__VITE_ASSET__Clb0FPXo__"